'use strict';

const fields = require('../../../../webapp/static-content/_versionedByRelease_/js/modules/utils/field.utils');
const inputPatternUtils = require('../../../../webapp/static-content/_versionedByRelease_/js/modules/utils/input_pattern_utils');
const processValidator = (validator) => {
    const hasValidatorType = Odigeo._.includes([
        'REGEX_VALIDATOR',
        'IDENTIFICATION_VALIDATOR_ES',
        'SECOND_EMAIL_VALIDATOR',
        'EMAIL_REGEX_RYANAIR',
    ], validator.validatorType);
    const regex = hasValidatorType ? validator.pattern : '';
    const regexInline = hasValidatorType ? validator.patternStartsWith : '';
    return Odigeo._.extend({}, validator, {
        regex,
        regexInline,
    });
};

const processAttributes = (options, removeConfirmEmailEnabled) => {
    const {attributes} = options;
    const autocomplete = attributes.autocomplete;
    const autocompleteEnabled = !!attributes.autocomplete;
    const isRequiredFieldOptional = options.requiredFieldOptional && options.requiredField === 'OPTIONAL';
    const required = !isRequiredFieldOptional && options.requiredField === 'required';
    const maxLength = attributes.maxLength === 0 ? '' : attributes.maxLength;
    return Odigeo._.extend({}, attributes, {
        autocomplete,
        autocompleteEnabled,
        maxLength,
        required,
        requiredOptional: isRequiredFieldOptional ? 'optional' : '',
        type: attributes.type || 'text',
    });
};

const trackError = (label, status, type, trackEvent) => {
    if ((status === 'invalid' || status === 'empty')) {
        trackEvent('payment_details_error', label +
            (type === 'inline' ? '_inline' : '_submit') +
            (status === 'empty' ? '_missing_error' : '_invalid_error'));
    }
};

const processOptions = (options, name) => {
    const removeConfirmEmailEnabled = options.removeConfirmEmailEnabled && options.attributes.type === 'email';
    const hoverTagEnabled = options.attributes.hoverTag === 'on';
    const attributes = processAttributes(options, removeConfirmEmailEnabled);
    const mandatorySymbol = attributes.required ? ' *' : '';
    const css = Odigeo._.extend({}, options.css, {
        hoverTag: hoverTagEnabled ? 'od-form-field-input-hover-tag' : '',
    });
    return Odigeo._.extend({}, options, {
        attributes,
        css,
        dataName: name,
        hoverTagEnabled,
        mandatorySymbol,
        removeConfirmEmailEnabled,
        validator: processValidator(options.validator),
    });
};

const getInputValue = ($input) => Odigeo.Utils.trim($input.val());
const syncInputValue = function() {
    this.$input.val(this.model.get('value'));
};
const syncStatus = (view) => {
    view.$validationField.attr('data-state', view.model.get('validationStatus'));
};

module.exports = Backbone.View.extend({
    events: {
        'tap .clear_input': 'clear',
        'blur input': 'onChange',
        'change input': 'onChange',
        'focus input': 'onFocus',
    },

    initialize(options) {
        this.options = processOptions(this.options, this.model.name);
        this.$el.prepend(this.options.template({
            keys: this.keys,
            options: this.options,
        }));
        this.$validationField = this.$el.find('.validation_field');
        this.$input = this.$el.find('input');
        this.$paymentRow = this.$input.closest('.paymentmanager_row');
        inputPatternUtils.initInputPattern(this.$input);
        this.listenTo(this.model, 'change:value', this.onChangeValue);
        this.listenTo(this.model, 'change:validationStatus', this.onChangeValidation);
        this.listenTo(this.model, 'fetch', syncInputValue);
        this.model.setValidationRegExp(this.$input.data('pattern'));
        this.trackEvent = options.trackEvent;
        this.label = options.label;
        this.setCardData = options.setCardData;
    },

    onChangeValue(model) {
        const value = model.get('value');
        const method = this.$input.closest('.card_form_wrapper').data('card');
        this.setCardData(method, {
            [model.name]: value,
        });
    },

    onChange() {
        const $input = this.$input;
        const value = getInputValue($input);
        Odigeo.Utils.apply($input);
        this.model.setValue(value);
        fields.showHidePlaceholder(this.$input, false);
        this.$paymentRow.removeClass('focused');
    },

    onFocus() {
        const $input = this.$input;
        this.model.set('validationStatus', 'validating');
        fields.showHidePlaceholder($input, true);
        this.$paymentRow.addClass('focused');
    },

    clear() {
        this.model.setValue('', {
            silent: true,
        });
        syncInputValue.call(this);
    },

    onValidationError(fullValidation) {
        const validationStatus = this.model.get('validationStatus');
        this.$validationField.attr('data-state', validationStatus);
        fields.showError(this.$validationField, false);
        trackError(this.label, validationStatus, fullValidation === true ? 'submit' : 'inline', this.trackEvent);
    },

    onChangeValidation(model, validationStatus, fullValidation) {
        this.onChangeValue(model);
        if (Odigeo._.includes(['init', 'validating', 'valid'], validationStatus)) {
            syncStatus(this);
        } else {
            this.onValidationError(fullValidation);
        }
    },
});
